import React from 'react';
import { Calendar } from 'lucide-react';
export function SevenDayPlan() {
  const days = [{
    day: '1',
    action: 'Identificás la ventana de sueño',
    feeling: 'Entendés la señal'
  }, {
    day: '2',
    action: 'Instalás el ritual de 15 min',
    feeling: 'Menos despertares'
  }, {
    day: '3',
    action: 'Aplicás bloqueo sonoro',
    feeling: 'El bus no molesta'
  }, {
    day: '4',
    action: 'Ajustás luz y temperatura',
    feeling: 'Anticipa el sueño'
  }, {
    day: '5',
    action: 'Consolidás la rutina',
    feeling: 'Hay un sistema'
  }, {
    day: '6',
    action: 'Protocolo de 3 pasos',
    feeling: '< 2 despertares'
  }];
  return <section className="py-12 md:py-16 bg-warm-100" data-id="element-239">
      <div className="max-w-4xl mx-auto px-4" data-id="element-240">
        <div className="text-center mb-8" data-id="element-241">
          <div className="inline-flex items-center gap-2 bg-primary-50 text-primary-600 px-4 py-2 rounded-full text-sm font-medium mb-3" data-id="element-242">
            <Calendar className="w-4 h-4" data-id="element-243" />
            <span data-id="element-244">Plan paso a paso</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-text-dark" data-id="element-245">
            El Plan de 7 Días
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-4" data-id="element-246">
          {days.map((item, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-sm" data-id="element-247">
              <div className="text-primary-500 font-bold text-sm mb-1" data-id="element-248">
                Día {item.day}
              </div>
              <p className="text-text-dark font-medium text-sm mb-1" data-id="element-249">
                {item.action}
              </p>
              <p className="text-text-muted text-xs" data-id="element-250">"{item.feeling}"</p>
            </div>)}
        </div>

        {/* Day 7 Highlight */}
        <div className="bg-primary-500 text-white p-5 rounded-2xl text-center" data-id="element-251">
          <div className="font-bold text-lg mb-1" data-id="element-252">Día 7</div>
          <p className="text-primary-100" data-id="element-253">Te despertás antes que el bebé.</p>
          <p className="font-semibold mt-1" data-id="element-254">
            Recordás cómo se siente haber dormido.
          </p>
        </div>
      </div>
    </section>;
}